import { combineReducers } from 'redux';
import shops from './shops/reducers';
import users from './users/reducers';
import brands from './brands/reducers';
import subscriptionPlans from './subscriptionPlans/reducer';
import subscriptions from './subscriptions/reducers';
import payouts from './splitsReport/reducer';
import { IMPERSONATE_USER } from '../auth/constants';
import * as types from './shops/constants';

const isFetching = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_SHOPS_REQUEST:
      return true;
    case types.FETCH_SHOPS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  shops,
  users,
  payouts,
  isFetching,
  brands,
  subscriptionPlans,
  subscriptions,
});

const resetReducer = (state, action) => {
  // cleanup after impersonate to free up memory
  if (action.type === IMPERSONATE_USER) {
    return reducer(undefined, action);
  }

  return reducer(state, action);
};

export default resetReducer;
